import React from 'react';
import {LinkComponent, LinkComponentProps, useLocalizationLocale} from 'epic-games-nav-shared';
import {Link, useLocation} from 'react-router-dom';
import classnames from 'classnames';
import queryString from 'query-string';
import root from 'window-or-global';

function isRemixPath(pathname: string): boolean {
  return (
    pathname.startsWith('/@') ||
    pathname.startsWith('/my-library') ||
    pathname.startsWith('/creative/island-codes/') ||
    pathname.startsWith('/categories') ||
    pathname === '/'
  );
}

export const FortniteLinkComponent: LinkComponent = ({
  path,
  externalHrefTemplate,
  explicitLocale,
  isEmbedded,
  locale,
  children,
  className,
  ...props
}: LinkComponentProps) => {
  const activeLocale = useLocalizationLocale();
  const location = useLocation();

  if (externalHrefTemplate) {
    const href = externalHrefTemplate.replace('{locale}', locale);
    return (
      <a href={href} className={className} {...props}>
        {children}
      </a>
    );
  }

  const isEsportsLink = new RegExp(`^/competitive`).test(path);
  const isOnEsports = new RegExp(`${root.appContext}/competitive`).test(root.location.href);
  const isLocaleSwitch = activeLocale !== locale;

  if (isLocaleSwitch) {
    // we use the full appContext here, as for competitive it needs to include `/competitive`
    return (
      <a href={`${root.appContext}${path}?lang=${locale}`} className={className} {...props}>
        {children}
      </a>
    );
  }

  const qs = queryString.parse(location.search);
  const to: {pathname: string; search?: string} = {
    pathname: `${path}`,
    // if the lang param is currently set, we want to propagate it to all
    // links. If undefined the lang param will be dropped
    search: queryString.stringify({lang: qs.lang}),
  };

  if (
    (isEsportsLink && !isOnEsports) ||
    (!isEsportsLink && isOnEsports) ||
    isRemixPath(to.pathname)
  ) {
    return (
      <a
        href={`${root.appContext}${to.pathname}${to.search ? `?${to.search}` : ''}`}
        className={className}
        {...props}>
        {children}
      </a>
    );
  }

  const pathIndex = location.pathname.indexOf(path);
  const activeLink = pathIndex === 0;
  const classNames = classnames(className, {active: activeLink});

  return (
    <Link to={to} className={classNames} {...props}>
      {children}
    </Link>
  );
};
